import api from './api';

export interface Notification {
  id: string;
  tipo: 'fatura' | 'relatorio' | 'documento' | 'ticket';
  titulo: string;
  mensagem?: string | null;
  link?: string | null;
  lida: boolean;
  createdAt: string;
}

export const notificationService = {
  async list(limit = 30): Promise<{ data: Notification[]; naoLidas: number }> {
    const response = await api.get(`/notifications?limit=${limit}`);
    return response.data;
  },

  async unreadCount(): Promise<number> {
    const response = await api.get('/notifications/unread-count');
    return response.data.naoLidas;
  },

  async markRead(id: string): Promise<void> {
    await api.patch(`/notifications/${id}/read`);
  },

  async markAllRead(): Promise<void> {
    await api.patch('/notifications/read-all');
  },
};
